import React from 'react';

import AspectRatio from './AspectRatio';
import CloseButton from './CloseButton';
import GradientBackground from './GradientBackground';
import RawHtml from './RawHtml';
import TabbedContent from './TabbedContent';
import TabbedDisplay from './TabbedDisplay';

import AboutContent from '~app/resources/credits/about.html';
import TeachersContent from '~app/resources/credits/teachers.html';
import CreditsContent from '~app/resources/credits/credits.html';

const CreditsScreen = ({
    onClose,
  }) => {
  return (
    <div className="CreditsScreen">

      <AspectRatio styleName="CreditsScreen__header">
        <AspectRatio styleName="CreditsScreen__headerBackground">
          <img
            src={require('~app/resources/images/credits/CreditsBanner.jpg')}
            alt="Credits Banner"
          />
        </AspectRatio>
        <div className="CreditsScreen__headerFade" />
        <AspectRatio styleName="CreditsScreen__headerLogo">
          <img
            src={require('~app/resources/images/credits/BiointeractiveLogo.svg')}
            alt="Biointeractive Logo"
          />
        </AspectRatio>
      </AspectRatio>

      <TabbedDisplay
        initialIndex={0}
      >
        <TabbedContent title="About">
          {renderAbout()}
        </TabbedContent>
        <TabbedContent title="Educator Materials">
          {renderEducators()}
        </TabbedContent>
        <TabbedContent title="Credits">
          {renderCredits()}
        </TabbedContent>
      </TabbedDisplay>

      <CloseButton
        onClick={onClose}
      />
    </div>
  );
};

function infoContainer(jsx) {
  return (
    <GradientBackground
      startColor={[47, 106, 145]}
      endColor={[29, 73, 99]}
    >
      {jsx}
    </GradientBackground>
  );
}

function renderAbout() {
  return infoContainer(
    <RawHtml
      htmlContent={AboutContent}
      styleName="credits"
    />
  );
}

function renderEducators() {
  return infoContainer(
    <RawHtml
      htmlContent={TeachersContent}
      styleName="credits"
    />
  );
}

function renderCredits() {
  return infoContainer(
    <RawHtml
      htmlContent={CreditsContent}
      styleName="credits"
    />
  );
}

export default CreditsScreen;



// WEBPACK FOOTER //
// ./src/components/CreditsScreen.js